import React from 'react';

const formatTisicov = (num) => {
  const n = Number(num || 0);
  return n.toLocaleString('sk-SK');
};

export function MenaVstupy({
  value,
  onChange,
  maxDigits = 7,
  maxValue,
  suffix = '€',
  placeholder = '0',
  className = '',
  wrapClassName = ''
}) {
  const toDisplay = (v) =>
    v === 0 ? '0' : (v ? formatTisicov(v) : '');

  const [display, setDisplay] = React.useState(toDisplay(value));

  React.useEffect(() => {
    setDisplay(toDisplay(value));
  }, [value]);

  const handleChange = (e) => {
    let digits = e.target.value.replace(/\D/g, '');
    if (digits.length > maxDigits) digits = digits.slice(0, maxDigits);

    const pretty = digits.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    setDisplay(pretty);

    onChange(digits ? Number(digits) : 0);
  };

  const handleBlur = () => {
    setDisplay(toDisplay(value));
  };

  return (
    <div className={`input-wrap ${wrapClassName}`}>
      <input
        type="text"
        inputMode="numeric"
        className={`form_input ${className}`}
        value={display}
        onChange={handleChange}
        onBlur={handleBlur}
        placeholder={placeholder}
      />
      <span className="input-suffix">{suffix}</span>
    </div>
  );
}

export function PercentaVstupy({
  value,
  onChange,
  maxInt = 2,
  decimalPlaces = 2,
  className = '',
  placeholder = '',
  wrapClassName = ''
}) {
  const pocetDesatinnychMiest = Math.min(
    6,
    Math.max(
      0,
      Number.isInteger(decimalPlaces)
        ? decimalPlaces
        : 2
    )
  );

  const toText = React.useCallback(
    (n) =>
      (Number(n) || 0)
        .toFixed(pocetDesatinnychMiest)
        .replace('.', ','),
    [pocetDesatinnychMiest]
  );

  const [text, setText] = React.useState(
    toText(value)
  );

  React.useEffect(() => {
    setText(toText(value));
  }, [value, toText]);

  const onChangeText = (e) => {
    const v = e.target.value.replace(/\s/g, '');

    const desatinnaCast =
      pocetDesatinnychMiest > 0
        ? `([.,]\\d{0,${pocetDesatinnychMiest}})?`
        : '';

    const re = new RegExp(
      `^\\d{0,${maxInt}}${desatinnaCast}$`
    );

    if (!re.test(v)) return;

    setText(v);

    const num = parseFloat(
      v.replace(',', '.')
    );

    if (!isNaN(num)) {
      onChange(num);
    } else {
      onChange(0);
    }
  };

  const onBlur = () => {
    const num = parseFloat(
      text.replace(',', '.')
    );

    const safe = isNaN(num)
      ? 0
      : num;

    const nasobok =
      10 ** pocetDesatinnychMiest;

    const zaokruhlenaHodnota =
      Math.round(
        (safe + Number.EPSILON) *
          nasobok
      ) / nasobok;

    onChange(zaokruhlenaHodnota);
    setText(toText(zaokruhlenaHodnota));
  };

  return (
    <div className={`input-wrap ${wrapClassName}`}>
      <input
        type="text"
        inputMode="decimal"
        className={`form_input ${className}`}
        value={text}
        onChange={onChangeText}
        onBlur={onBlur}
        placeholder={placeholder}
      />

      <span className="input-suffix">
        %
      </span>
    </div>
  );
}

export function IntegerVstupy({
  value,
  onChange,
  maxDigits = 2,
  min = 0,
  max,
  placeholder = ' ',
  className = '',
  wrapClassName = ''
}) {
  const [text, setText] = React.useState(String(value ?? ''));

  React.useEffect(() => {
    setText(String(value ?? ''));
  }, [value]);

  const handleChange = (e) => {
    let digits = e.target.value.replace(/\D/g, '');

    if (digits.length > maxDigits) digits = digits.slice(0, maxDigits);

    setText(digits);

    let num = digits ? Number(digits) : 0;

    if (typeof max === 'number' && num > max) num = max;
    if (typeof min === 'number' && num < min) num = min;

    onChange(num);
  };

  const handleBlur = () => {
    if (text === '') {
      onChange(0);
      setText('0');
    }
  };

  return (
    <input
      type="text"
      inputMode="numeric"
      className={`form_input ${className}`}
      value={text}
      onChange={handleChange}
      onBlur={handleBlur}
      placeholder={placeholder}
    />
  );
}